/*!
 * feature-toggle-service.js v4.1.1
 * https://willmendesneto.github.io/feature-toggle-service.js
 *
 * Licensed MIT © Will Mendes
 */
(function (global, factory) {
    if (typeof define === "function" && define.amd) {
        define("FeatureToggleService", ["exports"], factory);
    } else if (typeof exports !== "undefined") {
        factory(exports);
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports);
        global.FeatureToggleService = mod.exports;
    }
})(this, function (exports) {
    "use strict";

    var _a;
    Object.defineProperty(exports, "__esModule", { value: true });
    var version = '4.0.1';
    var settings = (_a = {}, _a[version] = {}, _a);
    /**
     * Checks if Feature toggle/flag exists and it's on.
     *
     * @param key - Feature toggle/flag key to be checked
     * @param debug - Prints configuration, version and settings for debug purposes
     *
     * @returns Boolean
     *
     */
    var isOn = function isOn(key, debug) {
        if (!!debug) {
            // tslint:disable-next-line
            console.log("\n[DEBUG] Execution Time in milliseconds: " + Date.now() + " version: \"" + version + "\" key: \"" + key + "\" settings: " + JSON.stringify(settings) + "\n");
        }
        return !!settings[version][key];
    };
    exports.isOn = isOn;
    /**
     * Set feature toggle/flag configuration
     *
     * @param obj - Configuration of your feature toggle/flag
     *
     * @returns void
     *
     */
    var set = function set(obj) {
        settings[version] = obj;
    };
    exports.set = set;
});